import { Config } from 'src/config/config';
export class Parameters{
    SERIAL_TEST = '1237019459';
    SERIAL_PROD = '1237019458';
    SERIAL = (new Config()).IS_TEST ? this.SERIAL_TEST : this.SERIAL_PROD;
    NOMBRE = "Apresma";
    SHAMAN_CLIENT_CODE = '';
    ONESIGNAL_APPID = '72083b12-9207-4fdd-93ed-a04965cc6255';
    ONESIGNAL_GOOGLEPROYECT = '761522745963';
    MASCARA = true;
    DOC = 'Documento';
    CUIT = 'Cuit';
    PASAPORTE = 'Pasaporte';
    PAIS = 'AR';
    VIDEOCALL_DESCRIPCION = 'Médico on-line';
    VIDEOCALL_SCHEDULED_DESCRIPCION = 'Programar Médico on-line';
    DOCTOR_DESCRIPCION = "Visita médica";
    DOCTOR_CALLME_DESCRIPCION = "Quiero que un médico me llame";
    VIDEOCALL_SCHEDULED_WARNING = "Recuerde estar atento al día y horario seleccionado";
    LOGIN_TYPE = 1;LOGIN_LEYEND = true;IMAGE_BACKGROUND_HOME=false;VALIDA_CLIENT_CODE=true;
}
